function cov_2oc995txv0() {
  var path = "/app/src/utils/render-to-decorator.ts";
  var hash = "7b043c6a6de5327b27e42345835809aa2ddecce2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/render-to-decorator.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 33
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 18
        },
        end: {
          line: 9,
          column: 38
        }
      },
      "2": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 23
        }
      },
      "3": {
        start: {
          line: 11,
          column: 16
        },
        end: {
          line: 11,
          column: 23
        }
      },
      "4": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 38
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 33
          },
          end: {
            line: 5,
            column: 34
          }
        },
        loc: {
          start: {
            line: 8,
            column: 5
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 23
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 11
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7b043c6a6de5327b27e42345835809aa2ddecce2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2oc995txv0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2oc995txv0();
import ReactDOM from 'react-dom';
import { getElement } from 'src/utils/get-element';
cov_2oc995txv0().s[0]++;
export var renderToDecorator = function renderToDecorator(selector, component) {
  cov_2oc995txv0().f[0]++;
  var element = (cov_2oc995txv0().s[1]++, getElement(selector));
  cov_2oc995txv0().s[2]++;
  if (!element) {
    cov_2oc995txv0().b[0][0]++;
    cov_2oc995txv0().s[3]++;
    return;
  } else {
    cov_2oc995txv0().b[0][1]++;
  }
  cov_2oc995txv0().s[4]++;
  ReactDOM.render(component, element);
};